/**
 * Connect swimlane — live-tail catch-up gate (OMON-227).
 *
 * Pure, dependency-free so the subtle staleness-vs-intent decision is unit-
 * testable without dragging in firebase / DOM / timers (sensor-series.ts, where
 * this used to sit, imports the firebase app and so can't load under vitest).
 */

/**
 * Should an unattended Connect view catch up to "now" on the next poll/refocus?
 *
 * YES only when it was **live-tailing** (parked at/near the right edge — user
 * intent, not a deliberate scrub into the past) AND its right edge has gone
 * **stale** (fallen beyond the live lookback while the tab/laptop slept). A view
 * the user scrubbed into the past (`liveTail=false`) is left where they put it;
 * a still-fresh view takes the cheap trailing merge instead.
 *
 * This is what makes "leave a swimlane unattended for 48h and come back to the
 * new days" true, without yanking a user who is studying last week back to now.
 */
export function shouldReanchorLive(
  viewEndMs: number,
  nowMs: number,
  liveTail: boolean,
  lookbackMs: number,
): boolean {
  return liveTail && viewEndMs < nowMs - lookbackMs;
}
